import {
  CustomHeaderKey,
  ImportResultsRecord
} from '@components/bid_request/details/types';
import { CustomColumnItem, CustomColumnType, Global, LineItem } from 'types';
import { buildCustomItems } from './buildCustomItems';
import { createLineItem } from './createLineItem';

interface BuildLineItemsParams {
  acceptSuggestedPriceColumn?: boolean,
  customHeaderIndexes: CustomHeaderKey[],
  global: Global,
  isPriceUpdate?: boolean,
  row: ImportResultsRecord,
}

/**
 * Builds a line item from the given row data.
 * @param props
 * @param props.acceptSuggestedPriceColumn
 * @param props.customHeaderIndexes
 * @param props.global
 * @param props.isPriceUpdate
 * @param props.row
 * @return {item: LineItem, errors: String[]}
 */
export const buildLineItem = ({
  acceptSuggestedPriceColumn = false,
  customHeaderIndexes,
  global,
  isPriceUpdate = false,
  row,
}: BuildLineItemsParams): LineItem => {
  const item = createLineItem(row, isPriceUpdate, acceptSuggestedPriceColumn);
  const descriptiveColumnType = global.lots.custom_column_headers.column_types.descriptive;

  item.custom_column_items = buildCustomItems(
    row,
    customHeaderIndexes,
    descriptiveColumnType as CustomColumnType
  ) as CustomColumnItem[];

  return item as LineItem;
};
